export default "__VITE_ASSET__BHNu2$ED__"